// app/javascript/controllers/visibility_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        controllerPath: String
    }

    connect() {
        this.updateVisibility();
    }

    updateVisibility() {
        const bodyControllerPath = document.body.getAttribute('data-controller-path');

        // Adjust visibility based on the current controller path
        if (bodyControllerPath === 'projects') {
            this.hideOrShowElements('project', false); // Hide elements for 'projects'
        } else if (bodyControllerPath === 'estimates') {
            this.hideOrShowElements('estimate', false); // Hide elements for 'estimates'
            this.hideOrShowElements('project', false); // Hide elements for 'projects'

        } else {
            // Show all elements if not in 'projects' or 'estimates'
            this.hideOrShowElements('project', true);
            this.hideOrShowElements('estimate', true);
        }
    }

    // Utility function to hide or show elements based on the target type
    hideOrShowElements(targetType, show) {
        this.element.querySelectorAll(`[data-visibility-target="${targetType}"]`).forEach(element => {
            element.style.display = show ? 'block' : 'none';
        });
    }
}
